import { FormControl, Validators } from '@angular/forms';
import { DataProtectionNoticeStatus } from '../constants';
import { countriesRequiredIfNotDefault } from './data-protection-notice.validator';

export class DataProtectionNotice {
  dpnId?: number;
  id?: number;
  data?: string;
  version?: string;
  status?: DataProtectionNoticeStatus;

  constructor(params?: DataProtectionNotice) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class DataProtectionNoticeItem {
  id?: number = null;
  countries: string[] | null = null;
  webCreateDpnVersionView: DataProtectionNotice = new DataProtectionNotice();
  defaultDpn: boolean;

  constructor(params?: DataProtectionNoticeItem) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class DataProtectionNoticeList {
  id?: number = null;
  countries: string[] | null = null;
  versions: DataProtectionNotice[] = [];
  defaultDpn: boolean;

  constructor(params?: DataProtectionNoticeItem) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class DpnItemForm {
  constructor(
    dpnItemModel: DataProtectionNoticeItem,

    public countries: FormControl<string[] | null> = new FormControl(dpnItemModel.countries, []),
    public defaultDpn: FormControl<boolean> = new FormControl(dpnItemModel.defaultDpn, [
      Validators.required,
      countriesRequiredIfNotDefault,
    ]),
    public webCreateDpnVersionView: FormControl<DataProtectionNotice> = new FormControl(
      dpnItemModel.webCreateDpnVersionView,
      [Validators.required],
    ),
  ) {}
}

export class DpnItemFileForm {
  dpnId?: number;

  constructor(
    dpnItemFileModel: DataProtectionNotice,

    public data: [string, Validators | Validators[]] = [
      dpnItemFileModel.data || null,
      dpnItemFileModel.dpnId ? [] : [Validators.required],
    ],
  ) {
    this.dpnId = dpnItemFileModel.dpnId || null;
  }
}
